import React, { useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { AppContext } from "../utilities/context";
import Container from "@mui/material/Container";
import Layout from "./Layout";
// import Grid from "@mui/material/Grid";
// import Styles from "../../public/assets/css/main.css";
import { Grid, Typography } from "@mui/material";
import { FormattedMessage, useIntl } from "react-intl";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
// import ListItemText from "@mui/material/ListItemText";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import PlaylistAddCheckIcon from "@mui/icons-material/PlaylistAddCheck";
// import CustomFilterDataGrid from "./CustomFilterDataGrid";

const Help = () => {
  const intl = useIntl();
  const context = useContext(AppContext);

  useEffect(() => {
    if (context) {
      context.updateBreadcrumbsState([
        {
          label: intl.formatMessage({ id: "app.header.home.label" }),
          url: "/",
        },
      ]);
    }
  }, []);

  // const columns = [
  //   { field: 'id', headerName: 'ID', width: 90, type: 'number' },
  //   { field: 'name', headerName: 'Nombre', width: 130 },
  //   { field: 'age', headerName: 'Edad', width: 90, type: 'number' },
  // ];

  // const rows = [
  //   { id: 1, name: 'Juan', age: 25 },
  //   { id: 2, name: 'María', age: 30 },
  // ];

  return (
    <Layout>
      <Container maxWidth={false} disableGutters>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h6" component="div">
              <FormattedMessage
                id="app.header.help.label"
                defaultMessage="Ayuda"
              />
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <List dense={false}>
              <ListItem>
                <ListItemIcon>
                  <PlaylistAddCheckIcon />
                </ListItemIcon>
                <Link to={"/terms"}>
                  <FormattedMessage
                    id="app.terms.title"
                    defaultMessage="Términos y Condiciones de QRDoor.click"
                  />
                </Link>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <HowToRegIcon />
                </ListItemIcon>
                <Link to={"/privacy"}>
                  <FormattedMessage
                    id="app.privacy.title"
                    defaultMessage="Política de Privacidad de QRDoor.click"
                  />
                </Link>
              </ListItem>
            </List>
          </Grid>
          {/* <Grid item xs={12}>
          <CustomFilterDataGrid rows={rows} columns={columns} />
          </Grid> */}
        </Grid>
      </Container>
    </Layout>
  );
};

export default Help;
